import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import GearIcon from 'components/atoms/icons/gear.svg?react';
import { type FC } from 'react';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

import type { GeneralCommentsMode } from '..';
import type { MenuProps } from 'antd';

interface SwitchModeButtonProps {
  isSingleMode: boolean;
  setGeneralCommentsMode?: (mode: GeneralCommentsMode) => void;
}

const SwitchModeButton: FC<SwitchModeButtonProps> = ({
  isSingleMode,
  setGeneralCommentsMode,
}) => {
  const { t } = useTranslation();

  const items: MenuProps['items'] = [
    {
      label: t('labels.switchToSplitView'),
      'data-cy': 'dropdown-edit-item',
      key: '0',
      onClick: () => setGeneralCommentsMode?.('split'),
      render: isSingleMode,
    },
    {
      label: t('labels.switchToSingleView'),
      'data-cy': 'dropdown-delete-item',
      key: '1',
      onClick: () => setGeneralCommentsMode?.('single'),
      render: !isSingleMode,
    },
  ].filter(({ render }) => render);

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
      rootClassName={s.menu}
    >
      <BaseButton
        onClick={(e) => e.preventDefault()}
        dataCy="switch-mode-dropdown-trigger"
        icon={<GearIcon width={16} height={16} />}
        type="secondary"
        className={s.trigger}
      />
    </Dropdown>
  );
};
export default SwitchModeButton;
